import Vue from "vue";
import { Component } from "vue-property-decorator";
import { tabItem } from "./models/tabItem";
import { EventBus, NavigateToEmitStr } from "./components/Controls/EventBus";
import ModalAlerte, { ModalAlerteOptions } from "./components/modalComponents/modalAlerte/modalAlerte";
import iNotPaieStorageKeys, { LocalStorageService } from "./components/Controls/LocalStorageService";
import { UtilisateurConnecteDto } from "./dto/GenApi.iNotPaie.Dto/UtilisateurConnecteDto";
import { Location } from "vue-router/types/router";
import { SocieteDto } from "./dto/GenApi.iNotPaie.Dto/SocieteDto";
import { ServicesFactoryInstance } from "./components/Controls/ServicesFactory";
import EventConstants, { RoleConstants } from "./components/Controls/EventConstants";
import { ParametresInstance } from "./components/Controls/Parameters";
import ModalTraitementEnCours from "./components/modalComponents/modalTraitementEnCours/modalTraitementEnCours";
import ModalCloturePaie from "./components/modalComponents/modalCloturePaie/modalCloturePaie";
import ModalVirementSepa from "./components/modalComponents/modalVirementSepa/modalVirementSepa";
import ModalDevalidationClotureExercice
	from "./components/modalComponents/modalDevalidationClotureExercice/modalDevalidationClotureExercice";
import ModalEnvoiBulletin, {
	ModalEnvoiBulletinOptions
} from "./components/modalComponents/modalEnvoiBulletin/modalEnvoiBulletin";
import { TraitementEnCoursDto } from "./dto/GenApi.iNotPaie.Dto/TraitementEnCoursDto";
import { TraitementEnCoursEnum } from "./dto/GenApi.iNotPaie.Dto/TraitementEnCoursEnum";
import { ParametrageModuleEnum } from "./dto/GenApi.iNotPaie.Dto/ParametrageModuleEnum";
import { ParametrageModuleIdEnum } from "./dto/GenApi.iNotPaie.Dto/ParametrageModuleIdEnum";
import ModalImporterTopaze from "./components/modalComponents/modalImporterTopaze/modalImporterTopaze";
import ModalEnqueteSatisfaction, {
	ModalEnqueteSatisfactionOptions
} from "./components/modalComponents/modalEnqueteSatisfaction/modalEnqueteSatisfaction";
import ModalEditionFinDeMois from "./components/modalComponents/modalEditionFinDeMois/modalEditionFinDeMois";
import ModalEditionFinDeMoisCumulees
	from "./components/modalComponents/modalEditionFinDeMoisCumulees/modalEditionFinDeMoisCumulees";
import ModalReeditionBulletins from "./components/modalComponents/modalReeditionBulletins/modalReeditionBulletins";
import ModalSalaries, { ModalSalariesOptions } from "./components/modalComponents/modalSalaries/modalSalaries";
import { ServiceEnqueteDeSatisfactionInstance } from "./components/enqueteDeSatisfaction/service";
import JimoHelper from "./Helper/JimoHelper";

@Component({
	components: {
		ContextComponent: require("./components/context/context.vue.html"),
		MenuComponent: require("./components/menu/menu.vue.html"),
		ModalAlerte: require("./components/modalComponents/modalAlerte/modalAlerte.vue.html"),
		ModalCloturePaie: require("./components/modalComponents/modalCloturePaie/modalCloturePaie.vue.html"),
		ModalVirementSepa: require("./components/modalComponents/modalVirementSepa/modalVirementSepa.vue.html"),
		ModalDevalidationClotureExercice: require("./components/modalComponents/modalDevalidationClotureExercice/modalDevalidationClotureExercice.vue.html"),
		ModalImporterTopaze: require("./components/modalComponents/modalImporterTopaze/modalImporterTopaze.vue.html"),
		ModalTraitementEnCours: require("./components/modalComponents/modalTraitementEnCours/modalTraitementEnCours.vue.html"),
		ModalEnvoiBulletin: require("./components/modalComponents/modalEnvoiBulletin/modalEnvoiBulletin.vue.html"),
		ModalEnqueteSatisfaction: require("./components/modalComponents/modalEnqueteSatisfaction/modalEnqueteSatisfaction.vue.html"),
		Authentication: require("./components/authentication/authentication.vue.html"),
		ModalEditionFinDeMois: require("./components/modalComponents/modalEditionFinDeMois/modalEditionFinDeMois.vue.html"),
		ModalEditionFinDeMoisCumulees: require("./components/modalComponents/modalEditionFinDeMoisCumulees/modalEditionFinDeMoisCumulees.vue.html"),
		ModalReeditionBulletins: require("./components/modalComponents/modalReeditionBulletins/modalReeditionBulletins.vue.html"),
		ModalSalaries: require("./components/modalComponents/modalSalaries/modalSalaries.vue.html")
	}
})
export default class App extends Vue {
	public activeMenu = false;
	public tabItems: tabItem[] = [];
	public tokenAcquired = false;
	public societeCourante?: SocieteDto = undefined;
	public isMenuVisible: boolean = false;
	public isFeatureFlagLoaded: boolean = false;
	public isCompletedContext: boolean = false;

	public utilisateurCourant?: UtilisateurConnecteDto = undefined;
	public historiqueNavigation: Location[] = [];

	public displayMenu = false;
	public traitementEnCours = false;

	public mounted(): void {
		EventBus.$on(NavigateToEmitStr, route => {
			this.historiqueNavigation = this.historiqueNavigation.filter(r => r.path != route.path);
			this.historiqueNavigation.push(route);

			if (this.checkDroitForRoute(route.path)) {
				this.$router.push(route);
			}
		});

		EventBus.$on(EventConstants.MANAGE_TAB_FROM_ROUTE, e => {
			this.manageTabFromRoute(e.path, e.name, e.vue);
		});

		EventBus.$on(EventConstants.CLOSE_TAB, path => {
			this.closeTab(path, false);
		});

		EventBus.$on("renameTab", e => {
			this.renameTab(e.route, e.newTitle);
		});

		// vérification de la présence dans l'url du fragment access_token (#stop)
		// si tel est le cas, on arrete le chargement de la page
		// utilie pour le dev, quand on ne veut pas que la gae soit redirigé vers la page sso
		if (window.location.hash != undefined && window.location.hash.indexOf("stop") != -1) {
			return;
		}

		const icare = this.findGetParameters("icare");
		if (icare != undefined && icare != LocalStorageService.get(iNotPaieStorageKeys.ICARE)) {
			console.warn("==> app.ts : icare has been found in the url");
			const url = this.getRedirectUrl();
			ServicesFactoryInstance.AuthenticationService.redirectToSSO(url, icare);

			return;
		}

		const state = this.findHashParameters("state");
		// vérification de la présence dans l'url du fragment access_token (#access_token=xxx) qui indique que le chargement de la page se fait suite a une redirection depuis la page de login SSO
		// si tel est le cas, on récupere le token pour le mettre en cache
		let access_token = this.findHashParameters("access_token");

		if (access_token != undefined) {
			console.warn("==> app.ts : hash has been found in the url");

			if (state != undefined && state == LocalStorageService.get(iNotPaieStorageKeys.OAUTH_STATE)) {
				console.warn("==> app.ts : state is OK");
				ServicesFactoryInstance.AuthenticationService.setToken({
					access_token: access_token,
					userName: ""
				});
				window.location.hash = "";
			} else {
				console.warn("==> app.ts : state is KO");
				ServicesFactoryInstance.AuthenticationService.removeToken();

				return;
			}
		}


		// récupération du token en cache
		const token = LocalStorageService.get(iNotPaieStorageKeys.TOKEN);
		if (token != undefined) {
			console.warn("==> app.ts : TokenAuthentication has been found in the local storage");
			ServicesFactoryInstance.AuthenticationService.setToken({
				access_token: token,
				userName: ""
			});
			// Simple appel qui permet de vérifier que le token est accépté par le serveur Paie
			ServicesFactoryInstance.AuthenticationService.Connect(this.connectionSuccess,
				() => {
					this.tokenAcquired = false;
				});
		} else {
			console.warn("==> app.ts : TokenAuthentication has not been found in the local storage");
			// si le token n'existe pas, redirection vers la page de login du SSO
			//  this.currentToken.token = '';
			ServicesFactoryInstance.AuthenticationService.removeToken();
			const url = this.getRedirectUrl();
			ServicesFactoryInstance.AuthenticationService.redirectToSSO(url, icare);
		}

		// vérification des droits sur la route à visiter
		this.$router.beforeEach((to, from, next) => {
			this.checkDroitForRoute(to.fullPath) ? next() : next(false);
		});
	}

	public setTraitement(value: boolean): void {
		this.traitementEnCours = value;
	}

	public connectionSuccess(): void {
		ServicesFactoryInstance.SignalRService.connect();

		ServicesFactoryInstance.ConfigurationEtude.get(data => {
			LocalStorageService.remove(iNotPaieStorageKeys.ICARE);

			if (data != undefined && data.NumeroIcare != undefined) {
				LocalStorageService.set(iNotPaieStorageKeys.ICARE, data.NumeroIcare);
			}
		});

		EventBus.$on(EventConstants.UTILISATEUR_CHANGED, this.OnUtilisateurChanged);
		EventBus.$on(EventConstants.UTILISATEUR_CHANGED, this.PushCustomJimoAttributesUtilisateur);
		EventBus.$on(EventConstants.MODAL_ALERT, this.OnModalAlerte);
		EventBus.$on(EventConstants.MODAL_CLOTURE_PAIE, this.OnModalCloturePaie);
		EventBus.$on(EventConstants.MODAL_VIREMENT_SEPA, this.OnModalVirementSepa);
		EventBus.$on(EventConstants.MODAL_DEVALIDATION_CLOTURE_EXERCICE, this.OnModalDevalidationClotureExercice);
		EventBus.$on(EventConstants.MODAL_IMPORTER_TOPAZE, this.OnModalImporterTopaze);
		EventBus.$on(EventConstants.MODAL_ENVOI_BULLETIN, this.OnModalEnvoiBulletin);
		EventBus.$on(EventConstants.MODAL_ENQUETE_SATISFACTION, this.OnModalEnqueteSatisfaction);
		EventBus.$on(EventConstants.MODAL_EDITION_FIN_DE_MOIS, this.OnModalEditionFinDeMois);
		EventBus.$on(EventConstants.MODAL_EDITION_FIN_DE_MOIS_CUMULEES, this.OnModalEditionFinDeMoisCumulees);
		EventBus.$on(EventConstants.MODAL_REEDITION_BULLETINS, this.OnModalReeditionBulletins);
		EventBus.$on(EventConstants.MODAL_SALARIES, this.OnModalSalaries);
		EventBus.$on(EventConstants.TRAITEMENT_EN_COURS, this.OnTraitementEnCours);
		EventBus.$on(EventConstants.MENU_INITIALIZATION_COMPLETED, this.OnMenuInitializationCompleted);
		EventBus.$on(EventConstants.FEATURE_FLAG_LOADED, this.OnFeatureFlagLoaded);
		EventBus.$on(EventConstants.SOCIETE_CHANGED, JimoHelper.setSocietettributes);

		LocalStorageService.addEventOnKey(iNotPaieStorageKeys.TOKEN, this.onStorageEvent);
		LocalStorageService.addEventOnKey(iNotPaieStorageKeys.ICARE, this.onStorageEvent);

		ServicesFactoryInstance.ParametrageModuleService.getParametrageModule(ParametrageModuleEnum.GENERAL, ParametrageModuleIdEnum.TRAITEMENT_EN_COURS, data => {
			if (data.StrData == TraitementEnCoursEnum[TraitementEnCoursEnum.Aucun] || data.StrData == undefined) {
				this.tokenAcquired = true;
			} else {
				this.OnTraitementEnCours({
					Action: TraitementEnCoursEnum[data.StrData],
					Description: "Un traitement est en cours"
				});
				EventBus.$once(EventConstants.TRAITEMENT_FINISHED, () => {
					this.tokenAcquired = true;
				});
			}
		});
	}

	public OnModalImporterTopaze(): void {
		const modal = this.$refs.modalImporterTopaze as ModalImporterTopaze;
		if (modal == undefined) {
			return;
		}
		modal.init();
	}

	public OnModalCloturePaie(): void {
		const modal = this.$refs.modalCloturePaie as ModalCloturePaie;
		if (modal == undefined) {
			return;
		}
		modal.init();
	}

	public OnModalVirementSepa(): void {
		const modal = this.$refs.modalVirementSepa as ModalVirementSepa;
		if (modal == undefined) {
			return;
		}
		modal.init();
	}

	public OnModalDevalidationClotureExercice(): void {
		const modal = this.$refs.modalDevalidationClotureExercice as ModalDevalidationClotureExercice;
		if (modal == undefined) {
			return;
		}
		modal.init();
	}

	public OnModalEnvoiBulletin(options: ModalEnvoiBulletinOptions): void {
		const modal = this.$refs.modalEnvoiBulletin as ModalEnvoiBulletin;
		if (modal == undefined) {
			return;
		}
		modal.init(options);
	}

	public OnModalAlerte(options: ModalAlerteOptions): void {
		const modalAlerte = this.$refs.modalAlerte as ModalAlerte;
		if (modalAlerte == undefined || options == undefined) {
			return;
		}
		modalAlerte.init(options);
	}

	public OnModalSalaries(options: ModalSalariesOptions): void {
		const modalSalaries = this.$refs.modalSalaries as ModalSalaries;
		if (modalSalaries == undefined || options == undefined) {
			return;
		}
		modalSalaries.init(options);
	}

	public OnModalEnqueteSatisfaction(options: ModalEnqueteSatisfactionOptions): void {
		const modal = this.$refs.modalEnqueteSatisfaction as ModalEnqueteSatisfaction;
		if (modal == undefined) {
			return;
		}
		modal.init(options);
	}

	public OnModalEditionFinDeMois(): void {
		const modal = this.$refs.modalEditionFinDeMois as ModalEditionFinDeMois;
		if (modal == undefined) {
			return;
		}
		modal.init();
	}

	public OnModalEditionFinDeMoisCumulees(): void {
		const modal = this.$refs.modalEditionFinDeMoisCumulees as ModalEditionFinDeMoisCumulees;
		if (modal == undefined) {
			return;
		}
		modal.init();
	}

	public OnModalReeditionBulletins(): void {
		const modal = this.$refs.modalReeditionBulletins as ModalReeditionBulletins;
		if (modal == undefined) {
			return;
		}
		modal.init();
	}

	public OnTraitementEnCours(dto: TraitementEnCoursDto): void {
		const modal = this.$refs.modalTraitementEnCours as ModalTraitementEnCours;
		if (modal == undefined || dto == undefined) {
			return;
		}

		if (dto.Action == TraitementEnCoursEnum.Aucun) {
			modal.fermer();
		} else {
			modal.init(dto);
		}
	}

	public OnMenuInitializationCompleted(): void {
		this.isMenuVisible = true;
	}

	public OnFeatureFlagLoaded(): void {
		this.isFeatureFlagLoaded = true;
	}

	public OnUtilisateurChanged(utilisateur: UtilisateurConnecteDto): void {
		this.utilisateurCourant = utilisateur;
		this.displayMenu = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]);
		const route: string[] = [];
		if (window.location.hash != undefined && this.checkDroitForRoute(window.location.hash.substr(1))) {
			route.push(window.location.hash.substr(1));
		}
		const t = this.findGetParameters("route");
		if (t != undefined) {
			route.push(t);
		}

		this.openDefaultTab();
		route.forEach(value => {
			if (this.checkDroitForRoute(value)) {
				EventBus.NavigateTo({ path: value });
				history.pushState(undefined, "Talent", window.location.origin + window.location.pathname + "#" + value);
			}
		});

		EventBus.$on(EventConstants.SOCIETE_CHANGED, this.OnSocieteChanged);
		EventBus.$on(EventConstants.SOCIETE_CHANGED, this.isEnqueteDeSatisfactionNeeded);
	}

	public PushCustomJimoAttributesUtilisateur(): void {
		JimoHelper.setUserAttributes(
			ParametresInstance.userHasRole(RoleConstants.Salarie),
			ParametresInstance.userHasRole(RoleConstants.Payeur),
			ParametresInstance.userHasRole(RoleConstants.UtilisateurPST),
			ParametresInstance.userHasRole(RoleConstants.AdministrateurPST),
			ParametresInstance.userHasRole(RoleConstants.Administrateur)
		);
	}

	public isEnqueteDeSatisfactionNeeded(): void {
		ServiceEnqueteDeSatisfactionInstance.enqueteDeSatisfaction();
	}

	public OnSocieteChanged(societe: SocieteDto): void {
		if (this.societeCourante != undefined) {
			const tempTabItems: tabItem[] = this.tabItems.map(obj => ({ ...obj }));
			
			for (let i = 1; i < tempTabItems.length; i++) {
				this.closeTab(tempTabItems[i].route, true);
			}
		}
		this.societeCourante = societe;
	}

	public getRedirectUrl(): string {
		let url = window.location.origin + window.location.pathname;
		const route = this.findGetParameters("route");
		if (route != undefined) {
			url = url + "?route=" + route;
		}

		return url;
	}

	public findGetParameters(parameterString: string): string | undefined {
		const parsedParams = {};
		location.search
			.substr(1)
			.split("&")
			.forEach(param => {
				const parts = param.split("=");
				parsedParams[parts[0]] = parts[1];
			});

		return parsedParams[parameterString];
	}

	public findHashParameters(parameterString: string): string | undefined {
		let hash = window.location.hash.substring(2);
		if (hash.indexOf("?") == 0) {
			hash = hash.substring(1);
		}

		const parsedParams = {};
		if (hash != undefined) {
			hash.split("&")
				.forEach(param => {
					const parts = param.split("=");
					parsedParams[parts[0]] = parts[1];
				});
		}

		return parsedParams[parameterString];
	}

	public onStorageEvent(e: any): void {
		if (e.key == iNotPaieStorageKeys.ICARE || e.key == iNotPaieStorageKeys.TOKEN) {
			const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
				{
					message: "Vous avez été déconnecté de votre session de travail",
					callBackYes: () :void => {
						window.location.reload();
					},
					canClose: false,
					showDialog: true,
					title: "Votre session a expiré"
				});
			EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);
		}
	}

	public toggleStateModeMenu(): void {
		this.activeMenu = !this.activeMenu;
	}

	public navigateTo(path: any): void {
		if (this.tabItems.filter(obj => obj.route == path) == undefined || this.tabItems.filter(obj => obj.route == path).length == 0) {
			return;
		}
		EventBus.NavigateTo(path);
	}

	public manageTabFromRoute(path: Location, name: any, vue: any): void {
		if (!this.checkDroitForRoute(path)) {
			return;
		}
		let needToAdd = true;
		this.tabItems.forEach(function(item: tabItem) {
			if (item.route.path == path.path) {
				item.active = true;
				needToAdd = false;
			} else {
				item.active = false;
			}
		});
		if (needToAdd) {
			this.tabItems.push({
				titre: name,
				route: path,
				id: this.tabItems.length,
				contentTab: vue,
				active: true,
				defaultClass: "",
				activeClass: "active"
			});
		}
	}

	public onCloseTab(path: Location): void {
		this.closeTab(path, false);
	}

	public renameTab(route: any, newTitle: any): void {
		this.tabItems.forEach(function(item: tabItem) {
			if (item.route.path == route.path) {
				item.titre = newTitle;
			}
		});
	}

	public closeTab(path: Location, withoutControl: boolean): void {
		const tabToClose = this.tabItems.filter(obj => obj.route.path == path.path);
		let location: Location | null | undefined;
		if (tabToClose.length == 1) {
			location = tabToClose[0].route;
		}

		if (location != undefined) {
			const vue = tabToClose[0].contentTab.default;
			if (vue != undefined) {
				if (!withoutControl && vue.checkIsModified != undefined && vue.checkIsModified(location)) {
					const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
						message: "L'onglet à fermer est en cours de modification. Souhaitez-vous vraiment le fermer ?",
						yesText: "OUI",
						noText: "NON",
						callBackYes: () :void => {
							if (vue != undefined && vue.closing != undefined) {
								vue.closing(location);
							}

							this.opentTabAfterClosing(location);

							EventBus.$emit(EventConstants.TAB_CLOSED, location);
						}
					});
					EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);

					return;
				}
				if (vue.closing !== undefined) {
					vue.closing(location);
				}
			}
		}

		this.opentTabAfterClosing(location);
		EventBus.$emit(EventConstants.TAB_CLOSED, location);
	}

	public opentTabAfterClosing(path: any): void {
		this.tabItems = this.tabItems.filter(obj => obj.route != path);
		this.historiqueNavigation = this.historiqueNavigation.filter(r => r.path != path.path);

		if (this.$router.currentRoute.path == path.path) {
			let destinationAfterClosing = this.historiqueNavigation[this.historiqueNavigation.length - 1];
			if (destinationAfterClosing == undefined || this.tabItems.filter(r => r.route.path == destinationAfterClosing.path).length == 0) {
				destinationAfterClosing = this.tabItems[0].route;
			}

			if (this.checkDroitForRoute(destinationAfterClosing)) {
				EventBus.NavigateTo(destinationAfterClosing);
			} else {
				EventBus.NavigateTo(this.tabItems[0].route);
			}
		}
	}

	public openDefaultTab(): void {
		if (this.checkDroitForRoute("/DashBoard")) {
			this.tabItems.push({
				titre: "",
				route: { path: "/DashBoard" },
				id: 0,
				active: true,
				defaultClass: "home",
				activeClass: "home active"
			});
			this.$router.push("/DashBoard");
		} else if (this.checkDroitForRoute("/gestionDesAbsences")) {
			this.$router.push("/gestionDesAbsences");
		}
	}

	public checkDroitForRoute(path: any): boolean {
		if (this.utilisateurCourant == undefined) {
			return false;
		}
		if (this.utilisateurCourant.Roles == undefined) {
			return false;
		}
		if (path == undefined) {
			return false;
		}
		const routes = this.$router.resolve(path);
		if (routes != undefined) {
			if (routes.route.name == "Erreur") {
				return true;
			}
			else {
				const route = routes.route.meta;
				if (route != undefined && route.roles != undefined) {
					for (let j = 0; j < route.roles.length; j++) {
						if (ParametresInstance.userIsAuthorized([RoleConstants[route.roles[j]]])) {
							if (ParametresInstance.societeCourante != undefined && !ParametresInstance.societeCourante.IsPaieActive) {
								return (route.roles as string[]).indexOf(RoleConstants.WithoutPaie) > 0;
							}

							return true;
						}
					}
				}
			}
		}

		return false;
	}

	public estModeBloque(): boolean {
		return ParametresInstance.modeBloque;
	}
}



// WEBPACK FOOTER //
// ./src/app.ts